import { DropdownEntitiesEnum } from '../../enums/dropdown-entities.enum';
import { ArrayMinSize, IsArray, IsOptional, IsUUID } from 'class-validator';
import { Transform } from 'class-transformer';
import { arrayOrStringToArray } from '../../types-transformers/array-transformers';
import { InterestSourcesEnum } from '../../enums';

export class DropdownsValuesRequestDto {
	@IsArray()
	@ArrayMinSize(1)
	public entities: DropdownEntitiesEnum[];
}

export class DropdownEntityValuesRequestDto {
	@Transform(arrayOrStringToArray)
	@IsOptional()
	@IsArray()
	@IsUUID('4', { each: true })
	public ids?: string[];

	@IsOptional()
	public limit?: number;

	@IsOptional()
	public sourceId?: InterestSourcesEnum;
}
